import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CommonSelect } from 'component/select';

/**
 * A functional component that renders a selector for choosing a sex option.
 */
export const SexSelector = ({ values, handleChange }) => {
    const { t } = useTranslation();
    const sexOptions = t('sexOptions', { returnObjects: true });
    return (
        <FormControl fullWidth>
            <InputLabel id="sex-label">{t('sex').toUpperCase()}</InputLabel>
            <CommonSelect
                id="sex-label"
                name="sex"
                label={t('sex').toUpperCase()}
                value={values.sex}
                onChange={handleChange}
                renderValue={(selected) => selected?.name || ''}
            >
                {sexOptions.map((option) => (
                    <MenuItem key={option.value} value={option}>
                        {option.name}
                    </MenuItem>
                ))}
            </CommonSelect>
        </FormControl>
    );
};

SexSelector.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired
};
